<ng-template #settingsTemplate></ng-template>
<ng-template #contentTemplate>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.42 43.76">
        <defs>
            <style>
                .stopwatch-cls-1 {
                    fill: #dfeef9;
                }
                .stopwatch-cls-2 {
                    fill: none;
                    stroke: #0090c9;
                    stroke-width: 0.45px;
                }
                .stopwatch-cls-3 {
                    fill: #0090c9;
                }
                .stopwatch-cls-4 {
                    fill: #008fcb;
                }
                .stopwatch-cls-5,
                .stopwatch-cls-6 {
                    fill: #fff;
                    stroke: #028ec9;
                }
                .stopwatch-cls-5 {
                    stroke-width: 0.01px;
                }
                .stopwatch-cls-6 {
                    stroke-width: 0.01px;
                }
            </style>
        </defs>
        <g id="playbutton">
            <rect
                class="stopwatch-cls-1"
                x="18.16"
                y="33.34"
                width="43.39"
                height="10.19"
                rx="2.96"
            />
            <rect
                class="stopwatch-cls-2"
                x="18.16"
                y="33.34"
                width="43.39"
                height="10.19"
                rx="2.96"
            />
            <path
                class="stopwatch-cls-3 play"
                (click)="start()"
                d="M26.27,38.21a15.32,15.32,0,0,0-2.94-2.29.34.34,0,0,0-.5.28,37.35,37.35,0,0,0,0,4.49.33.33,0,0,0,.5.28,14.51,14.51,0,0,0,2.94-2.29A.38.38,0,0,0,26.27,38.21Z"
                transform="translate(0 0)"
            />
            <path
                class="stopwatch-cls-3 pause"
                (click)="pause()"
                d="M38.38,36.22a5.72,5.72,0,0,0-1.17,0,.32.32,0,0,0-.3.32v3.81a.32.32,0,0,0,.3.32,5.72,5.72,0,0,0,1.17,0,.32.32,0,0,0,.3-.32V36.54A.32.32,0,0,0,38.38,36.22Zm2.94,0a5.72,5.72,0,0,0-1.17,0,.32.32,0,0,0-.3.32v3.81a.32.32,0,0,0,.3.32,5.72,5.72,0,0,0,1.17,0,.32.32,0,0,0,.3-.32V36.54A.32.32,0,0,0,41.32,36.22Z"
                transform="translate(0 0)"
            />
            <path
                class="stopwatch-cls-3 stop"
                (click)="stop()"
                d="M56.55,36.65a.39.39,0,0,0-.35-.35,16.48,16.48,0,0,0-3.58,0,.39.39,0,0,0-.35.35,16.57,16.57,0,0,0,0,3.59.39.39,0,0,0,.35.35,15.87,15.87,0,0,0,3.58,0,.39.39,0,0,0,.35-.35A16.57,16.57,0,0,0,56.55,36.65Z"
                transform="translate(0 0)"
            />
        </g>
        <g id="stopwatch">
            <rect
                class="stopwatch-cls-4"
                width="80.42"
                height="23.88"
                rx="4.06"
            />
            <g class="hours-lines">
                <g class="hours-lines-1">
                    @if (clock.hoursSegments.segmentZero.indexOf('a') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="6.27 11.63 5.51 10.89 5.51 6.19 6.27 5.47 7.1 6.25 7.1 10.87 6.27 11.63"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('b') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="6.27 18.48 5.51 17.76 5.51 13.1 6.27 12.36 7.1 13.14 7.1 17.72 6.27 18.48"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('c') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="12.63 5.84 7.3 5.84 6.56 5.08 7.32 4.27 12.62 4.27 13.39 5.06 12.63 5.84"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('d') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="12.63 12.79 7.3 12.79 6.56 12.03 7.33 11.2 12.63 11.2 13.39 12.01 12.63 12.79"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('e') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="12.63 19.7 7.33 19.7 6.56 18.89 7.3 18.11 12.63 18.11 13.39 18.89 12.63 19.7"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('f') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="13.7 11.63 12.95 10.89 12.95 6.19 13.7 5.47 14.54 6.25 14.54 10.87 13.7 11.63"
                    />
                    } @if (clock.hoursSegments.segmentZero.indexOf('g') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="13.7 18.48 12.95 17.76 12.95 13.1 13.7 12.36 14.54 13.14 14.54 17.72 13.7 18.48"
                    />
                    }
                </g>
                <g class="hour-lines-2">
                    @if (clock.hoursSegments.segmentOne.indexOf('a') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="17.05 11.56 16.29 10.82 16.29 6.13 17.05 5.41 17.88 6.18 17.88 10.81 17.05 11.56"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('b') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="17.05 18.42 16.29 17.7 16.29 13.04 17.05 12.3 17.88 13.08 17.88 17.66 17.05 18.42"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('c') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="23.42 5.78 18.08 5.78 17.34 5.02 18.1 4.2 23.4 4.2 24.18 5 23.42 5.78"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('d') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="23.42 12.73 18.08 12.73 17.34 11.97 18.12 11.14 23.42 11.14 24.18 11.95 23.42 12.73"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('e') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="23.42 19.64 18.12 19.64 17.34 18.82 18.08 18.05 23.42 18.05 24.18 18.82 23.42 19.64"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('f') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="24.49 11.56 23.73 10.82 23.73 6.13 24.49 5.41 25.32 6.18 25.32 10.81 24.49 11.56"
                    />
                    } @if (clock.hoursSegments.segmentOne.indexOf('g') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="24.49 18.42 23.73 17.7 23.73 13.04 24.49 12.3 25.32 13.08 25.32 17.66 24.49 18.42"
                    />
                    }
                </g>
            </g>
            <g class="dots">
                <path
                    class="stopwatch-cls-6"
                    d="M27.46,15.8l-1.07-1.1,1.07-1.07,1.09,1.07Z"
                    transform="translate(0 0)"
                />
                <path
                    class="stopwatch-cls-6"
                    d="M27.67,10.42,26.6,9.32l1.07-1.07,1.09,1.07Z"
                    transform="translate(0 0)"
                />
            </g>
            <g class="minutes-lines">
                <g class="minutes-lines-1">
                    @if (clock.minutesSegments.segmentZero.indexOf('a') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="30.73 11.69 29.97 10.95 29.97 6.25 30.73 5.53 31.56 6.31 31.56 10.93 30.73 11.69"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('b') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="30.73 18.54 29.97 17.82 29.97 13.16 30.73 12.42 31.56 13.2 31.56 17.78 30.73 18.54"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('c') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="37.1 5.9 31.76 5.9 31.02 5.14 31.78 4.33 37.08 4.33 37.85 5.12 37.1 5.9"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('d') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="37.1 12.85 31.76 12.85 31.02 12.1 31.8 11.26 37.1 11.26 37.85 12.08 37.1 12.85"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('e') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="37.1 19.77 31.8 19.77 31.02 18.95 31.76 18.17 37.1 18.17 37.85 18.95 37.1 19.77"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('f') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="38.16 11.69 37.41 10.95 37.41 6.25 38.16 5.53 39 6.31 39 10.93 38.16 11.69"
                    />
                    } @if (clock.minutesSegments.segmentZero.indexOf('g') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="38.16 18.54 37.41 17.82 37.41 13.16 38.16 12.42 39 13.2 39 17.78 38.16 18.54"
                    />
                    }
                </g>
                <g class="minutes-lines-2">
                    @if (clock.minutesSegments.segmentOne.indexOf('a') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="41.51 11.63 40.75 10.89 40.75 6.19 41.51 5.47 42.34 6.25 42.34 10.87 41.51 11.63"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('b') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="41.51 18.48 40.75 17.76 40.75 13.1 41.51 12.36 42.34 13.14 42.34 17.72 41.51 18.48"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('c') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="47.88 5.84 42.54 5.84 41.8 5.08 42.56 4.27 47.86 4.27 48.64 5.06 47.88 5.84"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('d') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="47.88 12.79 42.54 12.79 41.8 12.03 42.58 11.2 47.88 11.2 48.64 12.01 47.88 12.79"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('e') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="47.88 19.7 42.58 19.7 41.8 18.89 42.54 18.11 47.88 18.11 48.64 18.89 47.88 19.7"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('f') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="48.95 11.63 48.19 10.89 48.19 6.19 48.95 5.47 49.78 6.25 49.78 10.87 48.95 11.63"
                    />
                    } @if (clock.minutesSegments.segmentOne.indexOf('g') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="48.95 18.48 48.19 17.76 48.19 13.1 48.95 12.36 49.78 13.14 49.78 17.72 48.95 18.48"
                    />
                    }
                </g>
            </g>
            <g class="dots">
                <path
                    class="stopwatch-cls-6"
                    d="M52.36,15.76l-1.07-1.11,1.07-1.07,1.09,1.07Z"
                    transform="translate(0 0)"
                />
                <path
                    class="stopwatch-cls-6"
                    d="M52.58,10.38,51.51,9.27l1.07-1.06,1.08,1.06Z"
                    transform="translate(0 0)"
                />
            </g>
            <g class="seconds-line">
                <g class="seconds-line-1">
                    @if (clock.secondsSegments.segmentZero.indexOf('a') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="55.63 11.64 54.87 10.91 54.87 6.21 55.63 5.49 56.47 6.26 56.47 10.89 55.63 11.64"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('b') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="55.63 18.5 54.87 17.78 54.87 13.12 55.63 12.38 56.47 13.16 56.47 17.74 55.63 18.5"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('c') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="62 5.86 56.66 5.86 55.92 5.1 56.68 4.29 61.98 4.29 62.76 5.08 62 5.86"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('d') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="62 12.81 56.66 12.81 55.92 12.05 56.7 11.22 62 11.22 62.76 12.03 62 12.81"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('e') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="62 19.72 56.7 19.72 55.92 18.91 56.66 18.13 62 18.13 62.76 18.91 62 19.72"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('f') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="63.07 11.64 62.31 10.91 62.31 6.21 63.07 5.49 63.9 6.26 63.9 10.89 63.07 11.64"
                    />
                    } @if (clock.secondsSegments.segmentZero.indexOf('g') !==
                    -1) {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="63.07 18.5 62.31 17.78 62.31 13.12 63.07 12.38 63.9 13.16 63.9 17.74 63.07 18.5"
                    />
                    }
                </g>
                <g class="seconds-line-2">
                    @if (clock.secondsSegments.segmentOne.indexOf('a') !== -1) {
                    <polygon
                        class="stopwatch-cls-5 a"
                        points="66.41 11.58 65.66 10.84 65.66 6.15 66.41 5.43 67.25 6.2 67.25 10.82 66.41 11.58"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('b') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 b"
                        points="66.41 18.44 65.66 17.72 65.66 13.06 66.41 12.32 67.25 13.1 67.25 17.68 66.41 18.44"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('c') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 c"
                        points="72.78 5.79 67.44 5.79 66.7 5.04 67.46 4.22 72.76 4.22 73.54 5.02 72.78 5.79"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('d') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 d"
                        points="72.78 12.75 67.44 12.75 66.7 11.99 67.48 11.15 72.78 11.15 73.54 11.97 72.78 12.75"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('e') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 e"
                        points="72.78 19.66 67.48 19.66 66.7 18.84 67.44 18.07 72.78 18.07 73.54 18.84 72.78 19.66"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('f') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 f"
                        points="73.85 11.58 73.09 10.84 73.09 6.15 73.85 5.43 74.69 6.2 74.69 10.82 73.85 11.58"
                    />
                    } @if (clock.secondsSegments.segmentOne.indexOf('g') !== -1)
                    {
                    <polygon
                        class="stopwatch-cls-5 g"
                        points="73.85 18.44 73.09 17.72 73.09 13.06 73.85 12.32 74.69 13.1 74.69 17.68 73.85 18.44"
                    />
                    }
                </g>
            </g>
        </g>
    </svg>
</ng-template>
